/**
 * Filters and maps feature flags for analytics tracking
 * @param flags - Object containing feature flags
 * @param prefixes - Array of prefixes to filter flags by
 * @returns Array of feature flags formatted for analytics
 */
export const getFeatureFlagsForAnalytics = (flags: Record<string, boolean>, prefixes: string[]) => {
  return Object.entries(flags)
    .filter(([key]) => prefixes.some((prefix) => key.startsWith(prefix)))
    .map(([key, value]) => ({
      name: key,
      value: value ? 'variant' : 'control',
      vendor: 'launchdarkly',
    }));
};
